import SpringConfigs from 'utils/constants/swarm/spring-configs';

export const PRICE_SEPARATOR_REGEXP = SpringConfigs.PRICE_SEPARATOR
  ? new RegExp(SpringConfigs.PRICE_SEPARATOR, 'g')
  : '';
export const INVALID_NUMBER_REMOVAL_REGEX = /[^0-9.]/g;
